module.exports = __webpack_public_path__ + "static/media/visa-logo.54764d0a.svg";